import req from "@/assets/js/axios"
/* 科技mall*/
export default {
  // 条件查询机构
  getInstitutesHZ: (params) => {
    return req.apiAxios("POST", '/sctccHost/institute/InstituteController/getInstitutes', params)
  },
  // 条件查询热门店铺
  getHotInstituteHZ: (params) => {
    return req.apiAxios("POST", '/sctccHost/institute/InstituteController/getHotInstitute', params)
  },
  //条件查询机构扩展
  getInstituteExtendsHZ: (params) => {
    return req.apiAxios("POST", '/sctccHost/instituteExtend/InstituteExtendController/getInstituteExtends', params)
  },
  //条件查询服务
  getServicesHZ: (params) => {
    return req.apiAxios("POST", '/sctccHost/service/ServiceController/getServices', params)
  },
  //条件查询热门服务
  getHotServicesHZ: (params) => {
    return req.apiAxios("POST", '/sctccHost/service/ServiceController/getHotServices', params)
  },
  ///条件查询服务规格
  getServiceScalesHZ: (params) => {
    return req.apiAxios("POST", '/sctccHost/servicescale/ServiceScaleController/getServiceScales', params)
  },
  //创建服务超市订单
  operationServiceOrderHZ: (params) => {
    return req.apiAxios("POST", '/sctccHost/business/serviceorder/BServiceOrderController/operationServiceOrder', params)
  },
  //非创新券订单
  operationServiceOrderNotCouponHZ: (params) => {
    return req.apiAxios("POST", '/sctccHost/business/serviceorder/BServiceOrderController/operationServiceOrderNotCoupon', params)
  },
  //查询用户关注服务
  getUserServicesHZ: (params) => {
    return req.apiAxios("POST", '/sctccHost/intermediate/userfollow/userservice/UserServiceController/getUserServices', params)
  },
  //创建用户关注服务
  createUserServiceHZ: (params) => {
    return req.apiAxios("POST", '/sctccHost/intermediate/userfollow/userservice/UserServiceController/createUserService', params)
  },
  //删除用户关注服务
  deleteUserServiceHZ: (params) => {
    return req.apiAxios("POST", '/sctccHost/intermediate/userfollow/userservice/UserServiceController/deleteUserService', params)
  },
  //推荐商品查询
  recommendServiceHZ: (params) => {
    return req.apiAxios("POST", '/sctccHost/service/ServiceController/recommendService', params)
  },
  //添加店铺
  createFontInstituteHZ: (params) => {
    return req.apiAxios("POST", '/sctccHost/institute/InstituteController/createFontInstitute', params)
  },
  //修改店铺信息
  updateFontInstituteHZ: (params) => {
    return req.apiAxios("POST", '/sctccHost/institute/InstituteController/updateFontInstitute', params)
  },


  //查询园区店铺或商品
  getStarExtendsHZ: (params) => {
    return req.apiAxios("POST", '/sctccHost/starextend/StarExtendController/getStarExtends', params)
  },
  //创建园区店铺或商品
  createStarExtendHZ: (params) => {
    return req.apiAxios("POST", '/sctccHost/starextend/StarExtendController/createStarExtend', params)
  },
  //创建园区店铺或商品
  updateStarExtendHZ: (params) => {
    return req.apiAxios("POST", '/sctccHost/starextend/StarExtendController/updateStarExtend', params)
  },
  //园区店铺开设
  openBServiceShopHZ: (params) => {
    return req.apiAxios("POST", '/sctccHost/business/starextend/BStarExtendController/openBServiceShop', params)
  },
  //发布服务商品
  releaseServiceHZ: (params) => {
    return req.apiAxios("POST", '/sctccHost/business/service/BServiceController/releaseService', params)
  },
  //创建服务规格
  createFontServiceScaleHZ: (params) => {
    return req.apiAxios("POST", '/sctccHost/servicescale/ServiceScaleController/createFontServiceScale', params)
  },
  //更新服务规格
  updateFontServiceScaleHZ: (params) => {
    return req.apiAxios("POST", '/sctccHost/servicescale/ServiceScaleController/updateFontServiceScale', params)
  },
  //删除服务规格
  deleteServiceScaleHZ: (params) => {
    return req.apiAxios("POST", '/sctccHost/servicescale/ServiceScaleController/deleteServiceScale', params)
  },
  //创建服务
  createFrontServiceHZ: (params) => {
    return req.apiAxios("POST", '/sctccHost/service/ServiceController/createFrontService', params)
  },
  //更新服务
  updateFrontServiceHZ: (params) => {
    return req.apiAxios("POST", '/sctccHost/service/ServiceController/updateFrontService', params)
  },
  //条件查询服务超市订单
  getServiceOrders: (params) => {
    return req.apiAxios("POST", '/sctccHost/serviceorder/ServiceOrderController/getServiceOrders', params)
  },
  //催单
  reminder: (params) => {
    return req.apiAxios("POST", '/sctccHost/business/serviceorder/BServiceOrderController/serviceOrderReminder', params)
  },
  //服务订单操作（非创新券订单）
  operationServiceOrderNotCoupon: (params) => {
    return req.apiAxios("POST", '/sctccHost/business/serviceorder/BServiceOrderController/operationServiceOrderNotCoupon', params)
  },
  //处理详情
  getExamines: (params) => {
    return req.apiAxios("POST", '/host/examine/ExamineController/getExamines', params)
  },
  //评价详情
  getServiceOrderScores: (params) => {
    return req.apiAxios("POST", '/sctccHost/serviceorderscore/ServiceOrderScoreController/getServiceOrderScores', params)
  },
  //其它订单评价
  createOrderScore: (params) => {
    return req.apiAxios("POST", '/sctccHost/business/orderscore/BOrderScoreController/createOrderScore', params)
  },
  //其它订单评价
  createServiceOrderScore: (params) => {
    return req.apiAxios("POST", '/sctccHost/business/serviceorderscore/BServiceOrderScoreController/createServiceOrderScore', params)
  },
}
